/**
 * 퀵런 프로젝트 — 프로젝트 행이 없는 «퀵런 실행 이력 전용» 프로젝트. 실행 이력·결과 저장소·실행 화면이 이 id 를 쓰고,
 * BFF 의 이력 기록도 같은 값(`QUICKRUN_PROJECT_ID`)을 안다.
 *
 * 프로젝트 목록에 없으므로 «목록에 없는 프로젝트 = 삭제된 프로젝트» 판정(실행 목록의 이름표·작업 공간 묶음, 실행 화면의
 * 삭제된 프로젝트 판정)은 이 선언(`isRowlessProject`·`ROWLESS_PROJECTS`)으로 먼저 거른다.
 */
export const QUICKRUN_PROJECT_ID = '_quickrun';
export const QUICKRUN_PROJECT_NAME = '퀵 시뮬레이션';

/** 행 없이 존재하는 프로젝트 — id → 이름. 소속은 **그 사용자의 기본 워크스페이스 행**(사용자마다 다른 id 라 선언에 적을 수 없다 —
 *  소비자가 기본 행 id 를 받아 넣는다: runListModel.runProjectWorkspaces·useProjectListing) */
export const ROWLESS_PROJECTS: ReadonlyMap<string, { name: string }> = new Map([
  [QUICKRUN_PROJECT_ID, { name: QUICKRUN_PROJECT_NAME }],
]);

export const isRowlessProject = (projectId: string): boolean => ROWLESS_PROJECTS.has(projectId);
